import { SplideTrack, Splide, SplideSlide } from "@splidejs/react-splide";
import { React, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchBanners } from "./cl_Banners";
import useFilterGamesByType from "../../services/helper/filterGamesByType";
// import { setHomePopUp } from "../signIn/cl_SignInSlice";

const Banners = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterByGameType = useFilterGamesByType();
  const { superBannersData } = useSelector((state) => state.banners);
  const token = localStorage.getItem("gk");

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const handleBannerClick = (banner) => {
    // dispatch(setHomePopUp(true));
    const categoryName = banner.banner_name;

    if (!token) {
      localStorage.setItem(
        "intendedRoute",
        JSON.stringify({
          labelName: categoryName,
          menuLink: banner.banner_link,
          isGame: banner.banner_link.startsWith("/games/"),
        })
      );
      navigate("/signin");
      return;
    }

    if (banner.banner_link.startsWith("/games/")) {
      const gameType = banner.banner_link.split("/games/")[1];
      const filteredGames = filterByGameType(gameType);
      const gamesList =
        filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];

      const state = {
        gamesList,
        title: categoryName,
        game_type: gameType,
      };

      if (banner.newwindow === "Yes") {
        window.open(
          `/games/${gameType}?state=${encodeURIComponent(
            JSON.stringify(state)
          )}`,
          "_blank"
        );
      } else {
        navigate(`/games/${gameType}`, { state });
      }
    } else {
      if (banner.newwindow === "Yes") {
        window.open(banner.banner_link || "/", "_blank");
      } else {
        navigate(banner.banner_link || "/");
      }
    }
  };

  return (
    <div className="SB-superBanner">
      <Splide
        className="SB-splide-superBanner"
        hasTrack={false}
        options={{
          type: "loop",
          pagination: true,
          autoplay: true,
          autoWidth: true,
          arrows: false,
          focus: "center",
          lazyLoad: "sequential",
        }}
      >
        <SplideTrack>
          {Array.isArray(superBannersData) && superBannersData.length > 0
            ? superBannersData
              .filter(
                (bannerGroup) =>
                  bannerGroup.is_active &&
                  bannerGroup.master_typeid === 1 &&
                  (token
                    ? bannerGroup.after_login
                    : bannerGroup.before_login)
              )
              .map((bannerGroup, index) => (
                <SplideSlide key={index}>
                  <div
                    onClick={() => handleBannerClick(bannerGroup)}
                    style={{ cursor: "pointer" }}
                  >
                    {bannerGroup.imagepath ? (
                      <img
                        src={bannerGroup.imagepath}
                        alt={bannerGroup.banner_name}
                      />
                    ) : (
                      <div
                        style={{ width: "100%", height: "100%" }}
                        dangerouslySetInnerHTML={{ __html: bannerGroup.banner_image }}
                      />
                    )}
                  </div>
                </SplideSlide>
              ))
            : null}
        </SplideTrack>
      </Splide>
    </div>
  );
};

export default Banners;
